<script setup lang="ts">
import type { Address } from "@/schemas/address";

const props = defineProps<{ address: Address }>();
const countryLabel = computed(() => countries[props.address.country].name);
const stateLabel = computed(() => countries[props.address.country].states[props.address.state]);
</script>

<template>
  <address class="not-italic">
    {{ address.address_1 }}<br>
    {{ address.address_2 }}<br v-if="address.address_2">
    {{ address.city }} ({{ stateLabel }})
    {{ address.postcode }}<br>
    {{ countryLabel }}
  </address>
</template>
